import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div style={{ maxWidth: '1200px', padding: '24px', margin: '0 auto', textAlign: 'center' }}>
      <div style={{ paddingTop: 'var(--space-2xl)' }}>
        <span
          className="material-icons"
          style={{ fontSize: '64px', color: 'var(--text-tertiary)', marginBottom: 'var(--space-md)' }}
        >
          search_off
        </span>
        <h1 style={{ fontSize: 'var(--text-2xl)', color: 'var(--text-primary)', marginBottom: 'var(--space-sm)' }}>
          {t('notFound.title', 'Página no encontrada')}
        </h1>
        <p style={{ fontSize: 'var(--text-md)', color: 'var(--text-secondary)', marginBottom: 'var(--space-lg)' }}>
          {t('notFound.message', 'La ruta {{path}} no existe.', { path: location.pathname })}
        </p>
        <button type="button" className="btn btn-primary" onClick={() => navigate('/', { replace: true })}>
          {t('notFound.goHome', 'Ir al inicio')}
        </button>
      </div>
    </div>
  );
}

export default NotFoundPage;
